import { Controller } from 'stimulus'

const MAX_FILES = 4
const MAX_FILE_SIZE = 20 * 1024 * 1024 // 20 MB

export default class extends Controller {
  static targets = ['input', 'names', 'error']

  updateNames () {
    const files = Array.from(this.inputTarget.files)

    const tooManyFiles = files.length > MAX_FILES
    const oversizedFile = files.find(f => f.size > MAX_FILE_SIZE)

    if (tooManyFiles) {
      this.showError(this.inputTarget.dataset.errorTooManyFiles)
      this.inputTarget.value = ''
      this.namesTarget.textContent = ''
      return
    }

    if (oversizedFile) {
      this.showError(this.inputTarget.dataset.errorFileTooLarge)
      this.inputTarget.value = ''
      this.namesTarget.textContent = ''
      return
    }

    this.clearError()
    this.namesTarget.textContent = files.length > 0
      ? files.map(f => f.name).join(', ')
      : ''
  }

  showError (message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove('d-none')
  }

  clearError () {
    this.errorTarget.textContent = ''
    this.errorTarget.classList.add('d-none')
  }
}
